import { loadCommunity } from "../load";
import { hasFlag } from "app/stores/community";
import { CommunityFlags } from "app/models/flags";
import { error } from "@sveltejs/kit";
import { userSessions } from "app/stores/widget";
import { handleApiError } from "app/utils/errors";
import { sveltekitApiUrl } from "app/utils/urls";
import type { LayoutLoad } from "./$types";
import type {
  PaginatedUserSessionList,
  UserSession,
} from "@outverse-video/outverse-api-client-lib";

// disable across community - only enable ssr on a per-page basis
export const ssr = false;

/** Load community data */
export const load: LayoutLoad = async (event) => {
  const [communityData, initialUserSessions] = await Promise.all([
    // @ts-ignore
    loadCommunity(event),
    loadUserSessions(),
  ]);

  // check for widget flag using the resolved communityData
  if (!hasFlag(communityData.community.flags, CommunityFlags.WIDGET)) {
    console.log(`community: ${communityData.communitySlug} has no permission to view widget`);
    throw error(404);
  }

  async function loadUserSessions() {
    let initialUserSessions: UserSession[] = [];
    try {
      const userSessionsData: PaginatedUserSessionList = await fetch(
        `${sveltekitApiUrl()}/community/${event.params.community}/user-sessions`
      )
        .then(handleApiError)
        .then((response) => response.json());
      initialUserSessions = userSessionsData.results ?? [];
      userSessions.set(initialUserSessions);
    } catch (e) {
      console.error("Failed to load user sessions:", e);
      userSessions.set([]);
    }
    return initialUserSessions;
  }

  const isChromeExtension = event.url.searchParams.get("isChromeExtension") === "true";

  return {
    ...communityData,
    isChromeExtension,
    initialUserSessions,
  };
};
